import React from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import SharedIntlProviderHOC from '../shared-components/hocs/sharedIntlProviderHOC';

const SpaceTypeInfo = ({ intl }) => {
  const zendeskLocale = SharedIntlProviderHOC.getZendeskLocale();
  return (
    <div>
      <div className="">
        <h2>
          <FormattedMessage
            id="hosting.space_type_info.space_listing_heading"
            defaultMessage="What type of space are you listing?"
          />
        </h2>
        <p>
          <FormattedMessage
            id="hosting.space_type_info.space_listing_text"
            defaultMessage="Enter the type of space that most closely represents the physical space being listed."
          />
          &nbsp;
          <a href={`https://support.peerspace.com/hc/${zendeskLocale}/articles/360038421892`} target='_blank' rel="noreferrer" className="underline">
            <FormattedMessage
              id="hosting.space_type_info.learn_more_link_text"
              defaultMessage="Learn more"
            />
          </a>
        </p>
        <div className="flex middle tag-example-container">
          <img className="lightbulb-icon" src="/web-hosting/assets/images/lightbulb.svg?v=rb" alt={intl.formatMessage({ id: 'hosting.space_type_info.tag_lightbulb_image_alt', defaultMessage: 'lightbulb' })} />
          <p className="tag-examples">
            <FormattedMessage
              id="hosting.space_type_info.tag_examples"
              defaultMessage="Examples: 'Apartment' 'Photo Studio' 'Restaurant'"
            /></p>
        </div>
      </div>
    </div>
  );
};

SpaceTypeInfo.propTypes = {
  intl: intlShape
};

export default injectIntl(SpaceTypeInfo);
